/**
 * Thin wrapper around fetch for the WebNaTak API.
 * Reads the JWT token from localStorage and attaches it to requests.
 */

const API_BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('webnatak_token');
}

export function setToken(token) {
  localStorage.setItem('webnatak_token', token);
}

export function clearToken() {
  localStorage.removeItem('webnatak_token');
  localStorage.removeItem('webnatak_user');
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('webnatak_user'));
  } catch {
    return null;
  }
}

export function setStoredUser(user) {
  localStorage.setItem('webnatak_user', JSON.stringify(user));
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `HTTP ${res.status}`);
  }

  if (res.status === 204 || res.headers.get('content-length') === '0') return null;

  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/pdf')) return res.blob();
  return res.json();
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
  getPdf: (path) =>
    request(path).then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'faktura.pdf';
      a.click();
      URL.revokeObjectURL(url);
    }),
};
